import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';

class OnlinestatusService {

    private static readonly WAIT_MS = 5 * 60 * 1000;
    private static readonly API_ENDPOINT = '/identity/v0/users/@self/onlinestatus';

    private interval: number | undefined;
    private running: boolean = false;

    public startTracking() {
        if (!this.running) {
            this.running = true;
            this.trackOnlineStatus();
            this.interval = setInterval(() => {
                this.trackOnlineStatus();
            }, OnlinestatusService.WAIT_MS);
        }
    }

    public endTracking() {
        if (this.running) {
            this.running = false;
            clearInterval(this.interval);
        }
    }

    private trackOnlineStatus() {
        HTTP_SERVICE_INSTANCE.getAxiosWithoutLoginRedirect().put(
            `${OnlinestatusService.API_ENDPOINT}`,
            null
        );
    }
}

const ONLINE_STATUS_INSTANCE = new OnlinestatusService();

export {ONLINE_STATUS_INSTANCE};
